














	import Vue from "vue"
	import {mapState} from "vuex";
	import Game from "@/components/Game.vue";
export default Vue.extend({
	name: 'Scouting',
	components: {
		Game: Game
	},
	computed: {
		...mapState(['gameOptions', 'phase', 'activeGameIndex', 'numGames'])
	},
	methods: {
		chooseMission (optionIndex: number) {
			this.$store.dispatch('chooseMission', optionIndex)
		}
	}
})
